import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-top-menu',
    templateUrl: './top-menu.component.html'
})

export class TopMenuComponent  {
  @Output() public saveEvent = new EventEmitter<any>();

  closeWindow() {
    window.location.href = 'https://admin.plataformaasap.com.br/dashboard';
  }

  save() {
    this.saveEvent.emit();
  }
}
